export const colorPickerInputTheme = {
  input: {
    active: {
      bg: 'palette.surface.5',
      borderColor: 'palette.primary.40',
      borderRadius: '5px',
      borderWidth: '1px',
      fontSize: '14px',
      fontWeight: 400,
      text: 'palette.primary.99',
    },
    base: {
      bg: 'palette.surface.4',
      borderColor: 'palette.tertiary.5',
      borderRadius: '5px',
      borderWidth: '1px',
      fontSize: '14px',
      fontWeight: 400,
      text: 'palette.tertiary.60',
    },
    hover: {
      bg: 'palette.surface.5',
      borderColor: 'palette.tertiary.5',
      borderRadius: '5px',
      borderWidth: '1px',
      fontSize: '14px',
      fontWeight: 400,
      text: 'palette.tertiary.60',
    },
  },
  label: {
    fontWeight: 400,
    text: 'palette.neutral.80',
  },
};
